import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PieChartIcon from "@mui/icons-material/PieChart";
import HandshakeIcon from "@mui/icons-material/Handshake";
import FeedIcon from "@mui/icons-material/Feed";
import ForumIcon from "@mui/icons-material/Forum";
import HomeIcon from "@mui/icons-material/Home";
import MapIcon from "@mui/icons-material/Map";
import WarningIcon from "@mui/icons-material/Warning";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import KeyboardCommandKeyIcon from "@mui/icons-material/KeyboardCommandKey";
import LogoutIcon from "@mui/icons-material/Logout";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import BusinessIcon from "@mui/icons-material/Business";

const DEV_SERVER = false;
// if(!__DEV__) {
//   DEV_SERVER = false;
// }
let token = "";
const SERVER_ADDRESS = DEV_SERVER
  ? "http://192.168.1.10:3002/panel/"
  : "https://server.tasimacim.com/panel/";

const s = {};
s.SOCKET_ADDRESS = "https://server.tasimacim.com:4242"; //DEV_SERVER?"http://192.168.1.101:4242":"https://server.tasimacim.com:4242";
s.SERVER_ADDRESS = SERVER_ADDRESS;

s.allowedCities = {};
s.allowedCities[34] = {
  name: "İstanbul",
  id: 34,
  ilceler: [
    "Adalar",
    "Arnavutköy",
    "Ataşehir",
    "Avcılar",
    "Bağcılar",
    "Bahçelievler",
    "Bakırköy",
    "Başakşehir",
    "Bayrampaşa",
    "Beşiktaş",
    "Beykoz",
    "Beylikdüzü",
    "Beyoğlu",
    "Büyükçekmece",
    "Çatalca",
    "Çekmeköy",
    "Esenler",
    "Esenyurt",
    "Eyüpsultan",
    "Fatih",
    "Gaziosmanpaşa",
    "Güngören",
    "Kadıköy",
    "Kağıthane",
    "Kartal",
    "Küçükçekmece",
    "Maltepe",
    "Pendik",
    "Sancaktepe",
    "Sarıyer",
    "Silivri",
    "Sultanbeyli",
    "Sultangazi",
    "Şile",
    "Şişli",
    "Tuzla",
    "Ümraniye",
    "Üsküdar",
    "Zeytinburnu",
  ],
};
s.allowedCities[35] = {
  name: "İzmir",
  id: 35,
  ilceler: [
    "Aliağa",
    "Balçova",
    "Bayındır",
    "Bayraklı",
    "Bergama",
    "Beydağ",
    "Bornova",
    "Buca",
    "Çeşme",
    "Çiğli",
    "Dikili",
    "Foça",
    "Gaziemir",
    "Güzelbahçe",
    "Karabağlar",
    "Karaburun",
    "Karşıyaka",
    "Kemalpaşa",
    "Kınık",
    "Kiraz",
    "Konak",
    "Menderes",
    "Menemen",
    "Narlıdere",
    "Ödemiş",
    "Seferihisar",
    "Selçuk",
    "Tire",
    "Torbalı",
    "Urla",
  ],
};
s.allowedCities[9]=  { name: "Aydın", id: 9, ilceler: ["Efeler", "Kuşadası", "Didim", "Nazilli", "Söke", "Bozdoğan", "Çine", "Germencik", "Karacasu", "Koçarlı", "Köşk", "Sultanhisar", "Yenipazar"] }

s.allowedCities[6] = {
  name: "Ankara",
  id: 6,
  ilceler: [
    "Akyurt",
    "Altındağ",
    "Ayaş",
    "Balâ",
    "Beypazarı",
    "Çamlıdere",
    "Çankaya",
    "Çubuk",
    "Elmadağ",
    "Etimesgut",
    "Evren",
    "Gölbaşı",
    "Güdül",
    "Haymana",
    "Kahramankazan",
    "Kalecik",
    "Keçiören",
    "Kızılcahamam",
    "Mamak",
    "Nallıhan",
    "Polatlı",
    "Pursaklar",
    "Sincan",
    "Şereflikoçhisar",
    "Yenimahalle",
  ],
};

s.allowedCities[16] = {
  name: "Bursa",
  id: 16,
  ilceler: [
    "Nilüfer",
    "Osmangazi",
    "Yıldırım",
    "Büyükorhan",
    "Gemlik",
    "Gönen",
    "Harmancık",
    "İnegöl",
    "İznik",
    "Keles",
    "Karacabey",
    "Keşan",
    "Mudanya",
    "Mustafakemalpaşa",
    "Orhaneli",
    "Orhangazi",
    "Yenişehir",
    "Çekirge",
    "Kükürtlü",
    "Misi",
    "Bursa Merkez",
    "Çavuşoğlu",
    "Gölbaşı",
  ],
};

s.allowedCities[41] = {
  name: "Kocaeli",
  id: 41,
  ilceler: [
    "Başiskele",
    "Çayırova",
    "Darıca",
    "Derince",
    "Dilovası",
    "Gebze",
    "Gölcük",
    "İzmit",
    "Kandıra",
    "Karamürsel",
    "Kartepe",
    "Körfez",
  ],
};

s.allowedCities[54] = {
  name: "Sakarya",
  id: 54,
  ilceler: [
    "Adapazarı",
    "Akyazı",
    "Arifiye",
    "Erenler",
    "Ferizli",
    "Geyve",
    "Hendek",
    "Karapürçek",
    "Karasu",
    "Kaynarca",
    "Kocaali",
    "Pamukova",
    "Sapanca",
    "Serdivan",
    "Söğütlü",
    "Taraklı",
  ],
};

s.allowedCities[48] = {
  name: "Muğla",
  id: 48,
  ilceler: [
    "Bodrum",
    "Dalaman",
    "Datça",
    "Fethiye",
    "Kavaklıdere",
    "Köyceğiz",
    "Marmaris",
    "Menteşe",
    "Milas",
    "Ortaca",
    "Seydikemer",
    "Ula",
    "Yatağan",
  ],
};

s.NAVIGATIONS = [
  // Permission matrix used by panel navigation and route protection:
  // 0: Admin override, can access all routes regardless of item permission.
  // 1: Logistics / operations pages.
  // 2: Driver management pages.
  // 3: Driver application pages.
  // 4: General home / dashboard access.
  // 5: Finance, notifications, and control center pages.
  // 6: Support and CMS pages.
  // 7: Currently not mapped to a panel navigation item.
  // 8: Currently not mapped to a panel navigation item.
  // 9: Careers pages.
  {
    title: "GENEL",
  },
  {
    name: "Anasayfa",
    href: "/",
    icon: <HomeIcon />,
    permission: 4,
  },
  {
    name: "Lojistik",
    href: "/logistics",
    icon: <LocalShippingIcon />,
    permission: 1,
  },
  {
    name: "Esnek",
    href: "/flex",
    icon: <LocalShippingIcon />,
    permission: 1,
  },
  // The four main service types are listed together and consecutively:
  // Lojistik, Esnek, Evden Eve, Şehirlerarası.
  {
    name: "Evden Eve",
    href: "/home-moving",
    icon: <LocalShippingIcon />,
    permission: 1,
  },
  {
    name: "Şehirlerarası",
    href: "/intercity",
    icon: <LocalShippingIcon />,
    permission: 1,
  },
  {
    name: "Pazaryeri İadeleri",
    href: "/marketplace-refunds",
    icon: <PieChartIcon />,
    permission: 1,
  },
  {
    name: "Bekleyen Siparişler",
    href: "/pending-orders",
    icon: <ShoppingBagIcon />,
    permission: 1,
  },
  {
    name: "Finans",
    href: "/finance",
    icon: <PieChartIcon />,
    permission: 5,
  },
  {
    name: "Faturalama",
    href: "/driver-invoices",
    icon: <TextSnippetIcon />,
    permission: 10,
  },
  {
    name: "Canlı Harita",
    href: "/livemap",
    icon: <MapIcon />,
    permission: 1,
  },
  {
    name: "Bildirim Merkezi",
    href: "/notifications",
    icon: <NotificationsActiveIcon />,
    permission: 5,
  },
  {
    name: "Kontrol Paneli",
    href: "/controlcenter",
    icon: <KeyboardCommandKeyIcon />,
    permission: 5,
  },
  {
    title: "SÜRÜCÜ ORTAKLARI",
  },
  {
    name: "Sürücüler",
    href: "/drivers",
    icon: <HandshakeIcon />,
    permission: 2,
  },
  {
    name: "Belge Onayları",
    href: "/company-document-approvals",
    icon: <TextSnippetIcon />,
    permission: 2,
  },
  // {
  //     name: "Sürücüler",
  //     href: "/drivers",
  //     icon: <HandshakeIcon />,
  //     menu: [
  //         {
  //             name: "Finans",
  //             href: "/finance",
  //             icon: <PieChartIcon />
  //         }
  //     ]
  // },
  {
    name: "Başvurular",
    href: "/applications",
    icon: <FeedIcon />,
    permission: 3,
  },
  {
    name: "Kariyer Basvurulari",
    href: "/careers",
    icon: <WorkOutlineIcon />,
    permission: 9,
  },
  {
    title: "DESTEK MERKEZİ",
  },
  {
    name: "Canlı Yardım",
    href: "/livesupport",
    icon: <ForumIcon />,
    permission: 6,
  },
  {
    name: "Hızlı Yanıtlar",
    href: "/replies",
    icon: <ForumIcon />,
    permission: 6,
  },
  {
    name: "Uyarılar",
    href: "/warnings",
    icon: <WarningIcon />,
    permission: 6,
  },
  {
    title: "CMS",
  },
  {
    name: "Sürücü Duyuruları",
    href: "/driverannouncements",
    icon: <TextSnippetIcon />,
    permission: 6,
  },
  {
    name: "Sipariş Oluştur",
    href: "/createorder",
    icon: <TextSnippetIcon />,
    permission: 6,
  },
  {
    title: "YÖNETİM",
  },
  {
    title: "KURUMSAL YÖNETİM",
  },
  {
    name: "İşletmeler",
    href: "/businesses",
    icon: <BusinessIcon />,
    permission: 0,
  },
  {
    name: "Kullanıcılar ve Yetkiler",
    href: "/workers",
    icon: <AdminPanelSettingsIcon />,
    permission: 0,
  },

  {
    name: "Çıkış Yap",
    href: "/logout",
    icon: <LogoutIcon />,
    permission: 0,
  },
];

s.getTransactionDescription = (transaction) => {
  if (transaction.type == 0) {
    return (
      "Sipariş Komisyonu (#" +
      transaction.data.order.substring(18).toUpperCase() +
      ")"
    );
  } else if (transaction.type == 1) {
    if (!transaction.data || !transaction.data.order) return "Hoşgeldin Bonusu";

    return (
      "KK Sipariş Ödemesi (#" +
      transaction.data.order.substring(18).toUpperCase() +
      ")"
    );
  } else if (transaction.type == 5) {
    return "Bakiye Çekme";
  } else if (transaction.type == 4) {
    return "KK Bakiye Yatırma";
  } else if (transaction.type == 6) {
    return (
      "Panel Bakiye " +
      (transaction.value > 0 ? "Yatırma" : "Çekme") +
      " (" +
      transaction.data.description +
      ")"
    );
  } else if (transaction.type == 2) {
    return "Bahşiş";
  } else if (transaction.type == 7) {
    return "Cari Ödeme";
  }
};

s.fetchClient = (url, body, ai) => {
  return new Promise((resolve) => {
    //getToken().then(token => {

    //fetch('http://192.168.1.7:3000/' + url, {body: JSON.stringify(body), method:"POST",mode:"no-cors", headers: {'Content-Type': 'application/json', Authorization: 'Bearer '+token}}).then((e) => e.json()).then((e) => {

    // if(!body) body = {}
    // body.endpoint = url;
    // console.log(body);

    //http://192.168.1.104:3002/
    //fetch(DEV_SERVER?("http://35.241.204.128/" + url):('https://europe-west1-windy-collector-346317.cloudfunctions.net/handler?q='+url), {body: JSON.stringify(body), method:"POST",mode:"no-cors", headers: {'Content-Type': 'application/json', Authorization: 'Bearer '+token}}).then((e) => e.json()).then((e) => {

    //console.log(SERVER_ADDRESS+url);
    fetch("https://server.tasimacim.com/" + url, {
      body: JSON.stringify(body),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((e) => e.json())
      .then(async (e) => {
        if (e.token) {
          token = e.token;
          s.token = token;

          await global.setItem("bearerToken", e.token);
          //await localStorage.setItem("bearerToken", e.token);
        }

        if (e.user) {
          s.user = e.user;

          console.log(e.currentCall);
        }

        if (e.error) {
          //global.showError(e.error);
        }
        resolve(e);
      })
      .catch((e) => {
        console.log(e);
        //global.showError(global.getText("connectionError"));
      });
    //})
  });
};

s.sendFile = (url, formData) => {
  return new Promise((resolve) => {
    //getToken().then(token => {

    //fetch('http://192.168.1.7:3000/' + url, {body: JSON.stringify(body), method:"POST",mode:"no-cors", headers: {'Content-Type': 'application/json', Authorization: 'Bearer '+token}}).then((e) => e.json()).then((e) => {

    // if(!body) body = {}
    // body.endpoint = url;
    // console.log(body);

    //http://192.168.1.104:3002/
    //fetch(DEV_SERVER?("http://35.241.204.128/" + url):('https://europe-west1-windy-collector-346317.cloudfunctions.net/handler?q='+url), {body: JSON.stringify(body), method:"POST",mode:"no-cors", headers: {'Content-Type': 'application/json', Authorization: 'Bearer '+token}}).then((e) => e.json()).then((e) => {

    //console.log(SERVER_ADDRESS+url);

    console.log(formData.get("file"));
    fetch(SERVER_ADDRESS + url, {
      body: formData,
      method: "POST",
      headers: { Authorization: "Bearer " + token },
    })
      .then((e) => e.json())
      .then(async (e) => {
        resolve(e);
      })
      .catch((e) => {
        console.log(e);
        //global.showError(global.getText("connectionError"));
      });
    //})
  });
};

s.viewDocument = (request) => window.dispatchEvent(new CustomEvent("panel-document-view", { detail: request }));
s.fetchDocument = async (body, signal) => {
  const response = await fetch(SERVER_ADDRESS + "getcompanydocumentviewurl", { method: "POST", headers: { "Content-Type": "application/json", Authorization: "Bearer " + token }, body: JSON.stringify(body), cache: "no-store", signal });
  if (!response.ok || !/^(image\/(jpeg|png|webp)|application\/pdf)/.test(response.headers.get("Content-Type") || "")) throw new Error("Belge görüntülenemedi veya yetkiniz yok.");
  return response.blob();
};

s.fetch = (url, body, ai) => {
  return new Promise((resolve) => {
    //getToken().then(token => {

    //fetch('http://192.168.1.7:3000/' + url, {body: JSON.stringify(body), method:"POST",mode:"no-cors", headers: {'Content-Type': 'application/json', Authorization: 'Bearer '+token}}).then((e) => e.json()).then((e) => {

    // if(!body) body = {}
    // body.endpoint = url;
    // console.log(body);

    //http://192.168.1.104:3002/
    //fetch(DEV_SERVER?("http://35.241.204.128/" + url):('https://europe-west1-windy-collector-346317.cloudfunctions.net/handler?q='+url), {body: JSON.stringify(body), method:"POST",mode:"no-cors", headers: {'Content-Type': 'application/json', Authorization: 'Bearer '+token}}).then((e) => e.json()).then((e) => {

    //console.log(SERVER_ADDRESS+url);
    fetch((ai ? "https://ai.tasimacim.com/" : SERVER_ADDRESS) + url, {
      body: JSON.stringify(body),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((e) => e.json())
      .then(async (e) => {
        if (e.token) {
          token = e.token;
          s.token = token;
          await global.setItem("bearerToken", e.token);
          //await localStorage.setItem("bearerToken", e.token);
        }

        if (e.user) {
          s.user = e.user;

          s.currentCall = e.currentCall;
        }

        if (e.error) {
          //global.showError(e.error);
        }
        resolve(e);
      })
      .catch((e) => {
        console.log(e);
        //global.showError(global.getText("connectionError"));
      });
    //})
  });
};

s.panelFetch = (endpoint, body = {}) => s.fetch(endpoint, body);
s.getBusinesses = (body) => s.panelFetch("getbusinesses", body);
s.getBusiness = (body) => s.panelFetch("getbusiness", body);
s.saveBusiness = (body) => s.panelFetch("savebusiness", body);
s.deleteBusiness = (body) => s.panelFetch("deletebusiness", body);
s.getBusinessUsers = (body) => s.panelFetch("getbusinessusers", body);
s.saveBusinessUser = (body) => s.panelFetch("savebusinessuser", body);
s.deleteBusinessUser = (body) => s.panelFetch("deletebusinessuser", body);

s.getPlatformEmoji = (platform) =>
  platform == 0
    ? "🍎"
    : platform == 1
    ? "🤖"
    : platform == 2
    ? "🌐"
    : platform == 5
    ? "🧿"
    : platform == 6
    ? "💳"
    : "🤷";

const citiesById = [
  "",
  "Adana",
  "Adıyaman",
  "Afyon",
  "Ağrı",
  "Amasya",
  "Ankara",
  "Antalya",
  "Artvin",
  "Aydın",
  "Balıkesir",
  "Bilecik",
  "Bingöl",
  "Bitlis",
  "Bolu",
  "Burdur",
  "Bursa",
  "Çanakkale",
  "Çankırı",
  "Çorum",
  "Denizli",
  "Diyarbakır",
  "Edirne",
  "Elazığ",
  "Erzincan",
  "Erzurum",
  "Eskişehir",
  "Gaziantep",
  "Giresun",
  "Gümüşhane",
  "Hakkari",
  "Hatay",
  "Isparta",
  "Mersin",
  "İstanbul",
  "İzmir",
  "Kars",
  "Kastamonu",
  "Kayseri",
  "Kırklareli",
  "Kırşehir",
  "Kocaeli",
  "Konya",
  "Kütahya",
  "Malatya",
  "Manisa",
  "Kahramanmaraş",
  "Mardin",
  "Muğla",
  "Muş",
  "Nevşehir",
  "Niğde",
  "Ordu",
  "Rize",
  "Sakarya",
  "Samsun",
  "Siirt",
  "Sinop",
  "Sivas",
  "Tekirdağ",
  "Tokat",
  "Trabzon",
  "Tunceli",
  "Şanlıurfa",
  "Uşak",
  "Van",
  "Yozgat",
  "Zonguldak",
  "Aksaray",
  "Bayburt",
  "Karaman",
  "Kırıkkale",
  "Batman",
  "Şırnak",
  "Bartın",
  "Ardahan",
  "Iğdır",
  "Yalova",
  "Karabük",
  "Kilis",
  "Osmaniye",
  "Düzce",
];

citiesById.forEach((cityName, cityId) => {
  if (!cityId || !cityName) return;
  if (!s.allowedCities[cityId]) {
    s.allowedCities[cityId] = {
      name: cityName,
      id: cityId,
      ilceler: [],
    };
  }
});

s.getCityName = (id) => citiesById[id];

s.normalizeDistrictText = (value) =>
  `${value || ""}`
    .toLocaleLowerCase("tr-TR")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

s.getDistrictName = (address, cityId) => {
  if (!address) return null;

  const normalizedCityId = Number(cityId);
  const districts = s.allowedCities[normalizedCityId]?.ilceler;

  if (
    Array.isArray(districts) &&
    Number.isInteger(address.subId) &&
    districts[address.subId]
  ) {
    return districts[address.subId];
  }

  if (!Array.isArray(districts) || districts.length === 0) {
    return null;
  }

  const candidates = [
    address.district,
    address.ilce,
    address.town,
    address.Label,
    address.label,
    address.address,
  ].filter(Boolean);

  const normalizedDistricts = districts.map((district) => ({
    district,
    normalized: s.normalizeDistrictText(district),
  }));

  for (const candidate of candidates) {
    const normalizedCandidate = s.normalizeDistrictText(candidate);
    const matchedDistrict = normalizedDistricts.find(({ normalized }) =>
      normalizedCandidate.includes(normalized)
    );

    if (matchedDistrict) {
      return matchedDistrict.district;
    }
  }

  return null;
};

s.getLocationDisplayName = (address, cityId) => {
  if (!address) return "—";
  if (address.Label) return address.Label;
  if (address.label) return address.label;
  if (address.address) return address.address;

  const districts = s.allowedCities[cityId]?.ilceler;
  if (
    Array.isArray(districts) &&
    Number.isInteger(address.subId) &&
    districts[address.subId]
  ) {
    return districts[address.subId];
  }

  return "—";
};

s.getLocationDistrictDisplayName = (address, cityId) =>
  s.getDistrictName(address, cityId) || s.getLocationDisplayName(address, cityId);

s.getAddressLabel = (address) => {
  var extras = "";
  if (address) {
    // if(address.extra.buildingNO) extras += address.extra.buildingNO + " ";
    // if(address.extra.floorNO) extras += address.extra.floorNO + " ";
    if (address.building) extras += "Bina: " + address.building + " ";
    if (address.floor) extras += "Kat: " + address.floor + " ";
    if (address.door) extras += "No: " + address.door + " ";

    if (address.details) extras += "Müşteri Notu: " + address.details;
    extras = extras.replace(/\s{2,}/g, " ").trim();
  }

  return address.Label + (extras.length > 0 ? " · " + extras : "");
};

s.handleCache = (newCache) => {
  var newVersion = global.cache?.versions || [];
  var changed = false;
  if (!global.cache) global.cache = { versions: [] };
  if (newCache?.replies) {
    global.cache.replies = newCache.replies.value;
    global.cache.versions[0] = newCache.replies.version;
    changed = true;
  }
  if (newCache?.workers) {
    global.cache.workers = newCache.workers.value;
    global.cache.versions[1] = newCache.workers.version;
    changed = true;
  }

  if (changed) {
    localStorage.setItem("cache", JSON.stringify(global.cache));
  }
};

s.getWorkerName = (_id) => {
  return _id == "000000000000000000000000"
    ? "SİSTEM"
    : global.cache.workers.find((s) => s._id == _id)?.name;
};

s.hasPermission = (permission, user = s.user) => {
  if (!user?.permissions) return false;

  const permissions = user.permissions.map(Number);
  return permissions.includes(0) || permissions.includes(Number(permission));
};

s.PERMISSION_RULES = [
  { id: 10, label: "Muhasebe / Faturalama", description: "Fatura bilgisi, mağaza eşleştirme ve dosya indirme. Onay ve kural düzenleme hariç." },
  {
    id: -1,
    label: "Deaktif",
    description: "Giriş engellendi. Bu çalışan panele giriş yapamaz.",
  },
  { id: 0, label: "Admin yetkisi", description: "Panele tam erişim." },
  {
    id: 1,
    label: "Lojistik / operasyon",
    description: "Lojistik, Esnek, Bekleyen Siparişler, Canlı Harita.",
  },
  {
    id: 2,
    label: "Sürücü yönetimi",
    description: "Sürücüler ve ilgili sürücü yönetimi akışları.",
  },
  {
    id: 3,
    label: "Sürücü başvuruları",
    description: "Başvurular.",
  },
  {
    id: 4,
    label: "Genel anasayfa",
    description: "Anasayfa.",
  },
  {
    id: 5,
    label: "Finans / operasyon kontrolü",
    description:
      "Finans, Bildirim Merkezi, Kontrol Paneli, Son İşlemler blokları.",
  },
  {
    id: 6,
    label: "Destek / CMS",
    description:
      "Canlı Yardım, Hızlı Yanıtlar, Uyarılar, Sürücü Duyuruları, Sipariş Oluştur.",
  },
  {
    id: 7,
    label: "Kullanılmıyor",
    description: "Şu anda panelde bir menü öğesine bağlı değil.",
  },
  {
    id: 8,
    label: "Kullanılmıyor",
    description: "Şu anda panelde bir menü öğesine bağlı değil.",
  },
  {
    id: 9,
    label: "Kariyer erişimi",
    description: "Kariyer Basvurulari.",
  },
];

s.getPermissionRuleLabel = (permission) =>
  s.PERMISSION_RULES.find((rule) => rule.id === Number(permission))?.label ||
  `Yetki ${permission}`;

s.formatDateTR = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d)) return "—";
  return d.toLocaleString("tr-TR");
}

s.formatText=(value)=> {
  if (value === null || value === undefined || value === "")
    return "—";
  return String(value);
}

s.humanizeField=(field)=> {
  const map = {
    note: "Not",
    date: "Tarih",
    acquisitionType: "Edinim Türü",
    acquisitionNote: "Edinim Notu",
  };
  return map[field] || field;
}

s.getManageOrderRequests = (body) => s.fetch("getmanageorderrequests", body);
s.getManageOrderHistory = (body) => s.fetch("getmanageorderhistory", body);
s.respondManageOrderRequest = (body) =>
  s.fetch("respondmanageorderrequest", body);
s.rematchManageOrder = (body) => s.fetch("rematchmanageorder", body);
s.resolveManageOrderHelp = (body) =>
  s.fetch("resolvemanageorderhelp", body);
s.collectCashManageOrderExtraCharge = (body) =>
  s.fetch("collectcashmanageorderextracharge", body);

export default s;
